import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { MandateProvider, useMandate } from "./UpiMandate/MandateContext";
import HouseholdSearch     from "./UpiMandate/HouseholdSearch";
import ProviderSelection   from "./UpiMandate/ProviderSelection";
import MandateForm         from "./UpiMandate/MandateForm";
import MandateConfirmation from "./UpiMandate/MandateConfirmation";

// ─────────────────────────────────────────────────────────────────────────────
// Inner app — consumes MandateProvider context
// ─────────────────────────────────────────────────────────────────────────────
function InnerApp({ history, api_token, initialHouseholdNumber }) {
  const [screen, setScreen]       = useState(-1);
  const [searchKey, setSearchKey] = useState(0);
  const { update } = useMandate();

  function goTo(n) { setScreen(n); }

  function handleRetry() {
    update({ status: "idle", redirectType: "", redirectUrl: "", merchantUserId: "", authRequestId: "" });
    setScreen(1);
  }

  function handleHome() {
    update({ 
      status: "idle", 
      redirectType: "", 
      redirectUrl: "", 
      merchantUserId: "", 
      authRequestId: "", 
      selectedMember: null, 
      selectedProvider: null,
      searchedMembers: [],
      householdNumber: "",
      householdId: null,
      householdName: "",
      branchName: ""
    });
    setSearchKey((k) => k + 1);
    setScreen(-1);
  }

  return (
    <>
      {/* Always mounted so state (member list) survives back-navigation from ProviderSelection */}
      <div style={{ display: screen === -1 ? undefined : "none" }}>
        <HouseholdSearch
          key={searchKey}
          onNext={() => goTo(0)}
          onBack={() => history.goBack()}
          api_token={api_token}
          initialHouseholdNumber={initialHouseholdNumber}
        />
      </div>
      {screen === 0 && (
        <ProviderSelection
          onNext={() => goTo(1)}
          onBack={() => goTo(-1)}
          api_token={api_token}
        />
      )}
      {screen === 1 && (
        <MandateForm
          onNext={() => goTo(2)}
          onBack={() => goTo(0)}
          api_token={api_token}
        />
      )}
      {screen === 2 && (
        <MandateConfirmation onHome={handleHome} onRetry={handleRetry} onBack={handleRetry} />
      )}
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// UPI_autopay — entry point (function component)
// Handles checkForRequest logic (URL params from NACHRegisterBank redirect)
// ─────────────────────────────────────────────────────────────────────────────
function UPI_autopay({ history, location }) {
  const [ready, setReady]                               = useState(false);
  const [apiToken, setApiToken]                         = useState(null);
  const [initialHouseholdNumber, setInitialHHNumber]    = useState(null);

  useEffect(() => {
    const params   = new URLSearchParams(location.search);
    const urlToken = params.get("api_token");
    const urlHhNo  = params.get("lead_id");

    if (urlToken && urlHhNo) {
      // Coming from NACHRegisterBank.js (regtype == "upi") redirect:
      //   /upi_autopay?api_token=...&lead_id=...&e_id=...&b_id=...&u_id=...
      const e_id = params.get("e_id");
      if (!e_id || e_id === "null") {
        history.goBack();
        return;
      }
      localStorage.setItem("api_token",        urlToken);
      localStorage.setItem("branch_id",        params.get("b_id") || "");
      localStorage.setItem("e_designation_id", e_id);
      localStorage.setItem("in_userid",        params.get("u_id") || "");
      setApiToken(urlToken);
      setInitialHHNumber(urlHhNo);
    } else {
      // Normal navigation via React router state
      const locState = (location && location.state) || {};
      setApiToken(locState.api_token || localStorage.getItem("api_token"));
    }
    setReady(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ready) return null;

  return (
    <MandateProvider>
      <InnerApp
        history={history}
        api_token={apiToken}
        initialHouseholdNumber={initialHouseholdNumber}
      />
    </MandateProvider>
  );
}

export default withRouter(UPI_autopay);

